import { useState } from 'react'
import Popout from '../components/Popout'
import ellipsis from './ellipsis-icon.png'
import './VirtualBackgroundMenu.css'
import Dropdown from 'rc-dropdown'
import 'rc-dropdown/assets/index.css'
import DropdownOptions from './DropdownOptions'
import { useSelector } from 'react-redux'
import { selectIsZaConfigPending } from '../root/reducer'

const VirtualBackgroundMenu = () => {
  const [isHover, setIsHover] = useState(false)
  const zaConfigIsPending = useSelector(selectIsZaConfigPending)

  const onMouseEnter = () => {
    setIsHover(true)
  }

  const onMouseLeave = () => {
    setIsHover(false)
  }

  return (
    <Popout content="Set background to" visible={isHover} placement="topRight">
      <Dropdown
        trigger={['click']}
        overlay={<DropdownOptions zaConfigIsPending={zaConfigIsPending} />}
      >
        <button
          className="VB__menu"
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          <img src={ellipsis} alt="ellipsis" />
        </button>
      </Dropdown>
    </Popout>
  )
}

export default VirtualBackgroundMenu
